export enum EnumCommentEntityType {
    ExternalNewsArticle = 1,
    Wikifolio = 2,
    Underlying = 3,
}

export enum EnumCommentStatus {
    Created = 1,
    Updated = 2,
    Deleted = 3,
}
